import React, {Component} from 'react'
import {Tabs, Radio, Checkbox, Row, Col, InputNumber, Form} from 'antd'
import {withTranslation} from 'react-i18next'

class CronGenerator extends Component {
  formRef = React.createRef()
  createCheckbox = (key, col, minNum, maxNum) => {
    let colArray = []
    let rowArray = []
    let count = col
    let keyNum = minNum
    for (minNum; minNum <= maxNum; minNum++) {
      let checkbox = <Col style={{marginRight: '5px'}} key={key + keyNum}><Checkbox key={key + keyNum}
                                                                                    value={minNum}>{this.formatNum(minNum)}</Checkbox></Col>
      if (count > 0) {
        colArray.push(checkbox)
        count--
        if (minNum === maxNum) rowArray.push(<Row key={key + keyNum}>{colArray}</Row>)
      } else {
        rowArray.push(<Row key={key + keyNum}>{colArray}</Row>)
        colArray = []
        minNum--
        count = col
      }
      keyNum++
    }
    return <Row>{rowArray}</Row>
  }
  formatNum = (num) => {
    if (num < 10 && num > -1) {
      return '0' + num
    }
    return num
  }

  onChange = (key) => {
    const {periodValue, loopValue} = this.props
    if (key === '3') {
      //   this.formRef.current.setFieldsValue({
      //     periodMinuteMin: periodValue.minute.min,
      //     periodMinuteMax: periodValue.minute.max,
      //     loopMinuteStart: loopValue.minute.start,
      //     loopMinuteEnd: loopValue.minute.end,
      //   })
      // }else if(key==='3'){
      this.formRef.current.setFieldsValue({
        periodHourMin: periodValue.hour.min,
        periodHourMax: periodValue.hour.max,
        loopHourStart: loopValue.hour.start,
        loopHourEnd: loopValue.hour.end,
      })
    } else if (key === '4') {
      this.formRef.current.setFieldsValue({
        periodDayMin: periodValue.day.min,
        periodDayMax: periodValue.day.max,
        loopDayStart: loopValue.day.start,
        loopDayEnd: loopValue.day.end,
      })
    } else if (key === '5') {
      this.formRef.current.setFieldsValue({
        periodMonthMin: periodValue.month.min,
        periodMonthMax: periodValue.month.max,
        loopMonthStart: loopValue.month.start,
        loopMonthEnd: loopValue.month.end,
      })
    } else if (key === '6') {
      this.formRef.current.setFieldsValue({
        periodWeekMin: periodValue.week.min,
        periodWeekMax: periodValue.week.max,
      })
    }
  }

  render() {
    const {TabPane} = Tabs
    const {
      handleRadioChange,
      handleCheckboxChange,
      radioValue,
      cronParams,
      periodValue,
      handlePeriodChange,
      loopValue,
      handleLoopChange,
      t
    } = this.props
    const radioStyle = {display: 'block',}
    const inputStyle = {width: '50px',}
    const secondCheckbox = this.createCheckbox('second', 6, 0, 59)
    const minuteCheckbox = this.createCheckbox('minute', 6, 0, 59)
    const hourCheckbox = this.createCheckbox('hour', 12, 0, 23)
    const dayCheckbox = this.createCheckbox('day', 6, 1, 31)
    const monthCheckbox = this.createCheckbox('month', 12, 1, 12)
    const weekCheckbox = this.createCheckbox('week', 7, 1, 7)
    return (
      <>
        <Form ref={this.formRef} initialValues={{
          periodMinuteMin: periodValue.minute.min,
          periodMinuteMax: periodValue.minute.max,
          loopMinuteStart: loopValue.minute.start,
          loopMinuteEnd: loopValue.minute.end,
        }}>
          <Tabs type="card" tabPosition="left" className="apiTabs" onChange={this.onChange}>
            <TabPane tab={t(`general.second`)} key="1">
                <Radio.Group onChange={e => handleRadioChange(e,'second')} value={radioValue['second']}>
                    <Radio style={radioStyle} value={1}>
                      {t(`job.executedPerSecond`)}
                    </Radio>
                    <Radio style={radioStyle} value= 'period'>
                      {t(`job.periodFrom`)}
                        <InputNumber style={inputStyle} size="small" min={1} max={59} value={periodValue.second.min} defaultValue={1} onChange={e => handlePeriodChange(e,'second','min')} />
                        {t(`job.to`)}
                        <InputNumber style={inputStyle} size="small" min={1} max={59} value={periodValue.second.max} defaultValue={1} onChange={e => handlePeriodChange(e,'second','max')}/>
                      {t(`general.second`)}
                    </Radio>
                    <Radio style={radioStyle} value='loop'>
                      {t(`job.from`)}
                        <InputNumber style={inputStyle} size="small" min={1} max={59} value={loopValue.second.start} defaultValue={1} onChange={e => handleLoopChange(e,'second','start')}/>
                      {t(`job.secondStartPer`)}
                        <InputNumber style={inputStyle} size="small" min={1} max={59} value={loopValue.second.end} defaultValue={1} onChange={e => handleLoopChange(e,'second','end')}/>
                      {t(`job.secondExecuteOnce`)}
                    </Radio>
                    <Radio style={radioStyle} value='point'>{t(`job.assign`)}</Radio>
                     <Checkbox.Group style={{ width: '100%' }} onChange={e => handleCheckboxChange(e,'second')} value={cronParams.second}>
                            {secondCheckbox}
                        </Checkbox.Group>
                </Radio.Group>
            </TabPane>
            <TabPane tab={t(`general.minute`)} key="2">
              <Radio.Group value={radioValue['minute']} onChange={e => handleRadioChange(e, 'minute')}>
                <Radio style={radioStyle} value={1}>
                  {t(`job.executedPerMinute`)}
                </Radio>
                <Radio style={radioStyle} value="period">
                  {t(`job.periodFrom`)}
                  {/*<Form.Item name='periodMinuteMin' style={{width:50, display: 'table-row'}}>*/}
                  <InputNumber style={inputStyle} size="small" min={0} max={59} value={periodValue.minute.min}
                               onChange={e => handlePeriodChange(e, 'minute', 'min')}/>
                  {/*</Form.Item>*/}
                  {t(`job.to`)}
                  {/*<Form.Item name='periodMinuteMax' style={{width:50, display: 'table-row'}}>*/}
                  <InputNumber style={inputStyle} size="small" min={0} max={59} value={periodValue.minute.max}
                               onChange={e => handlePeriodChange(e, 'minute', 'max')}/>
                  {/*</Form.Item>*/}
                  {t(`general.minute`)}
                </Radio>
                <Radio style={radioStyle} value="loop">
                  {t(`job.from`)}
                  {/*<Form.Item name='loopMinuteStart' style={{width:50, display: 'table-row'}}>*/}
                  <InputNumber style={inputStyle} size="small" min={0} max={59} value={loopValue.minute.start}
                               onChange={e => handleLoopChange(e, 'minute', 'start')}/>
                  {/*</Form.Item>*/}
                  {t(`job.minuteStartPer`)}
                  {/*<Form.Item name='loopMinuteEnd' style={{width:50, display: 'table-row'}}>*/}
                  <InputNumber style={inputStyle} size="small" min={0} max={59} value={loopValue.minute.end}
                               onChange={e => handleLoopChange(e, 'minute', 'end')}/>
                  {/*</Form.Item>*/}
                  {t(`job.minuteExecuteOnce`)}
                </Radio>
                <Radio style={radioStyle} value="point">
                  {t(`job.assign`)}
                </Radio>
                <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'minute')} value={cronParams.minute}>
                  {minuteCheckbox}
                </Checkbox.Group>
              </Radio.Group>
            </TabPane>
            <TabPane tab={t(`general.hour`)} key="3">
              <Radio.Group onChange={e => handleRadioChange(e, 'hour')} value={radioValue['hour']}>
                <Radio style={radioStyle} value={1}>
                  {t(`job.executedPerHour`)}
                </Radio>
                <Radio style={radioStyle} value="period">
                  {t(`job.periodFrom`)}
                  <Form.Item name="periodHourMin" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={0}
                                                                                                         max={23} initialValue={periodValue.hour.min}
                                                                                                         onChange={e => handlePeriodChange(e, 'hour', 'min')}/></Form.Item>
                  {t(`job.to`)}
                  <Form.Item name="periodHourMax" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={0}
                                                                                                         max={23} initialValue={periodValue.hour.max}
                                                                                                         onChange={e => handlePeriodChange(e, 'hour', 'max')}/></Form.Item>
                  {t(`general.hour`)}
                </Radio>
                <Radio style={radioStyle} value="loop">
                  {t(`job.from`)}
                  <Form.Item name="loopHourStart" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={0}
                                                                                                         max={23} initialValue={loopValue.hour.start}
                                                                                                         onChange={e => handleLoopChange(e, 'hour', 'start')}/></Form.Item>
                  {t(`job.hourStartPer`)}
                  <Form.Item name="loopHourEnd" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={0}
                                                                                                       max={23} initialValue={loopValue.hour.end}
                                                                                                       onChange={e => handleLoopChange(e, 'hour', 'end')}/></Form.Item>
                  {t(`job.hourExecuteOnce`)}
                </Radio>
                <Radio style={radioStyle} value="point">
                  {t(`job.assign`)}
                </Radio>
                <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'hour')} value={cronParams.hour}>
                  {hourCheckbox}
                </Checkbox.Group>
              </Radio.Group>
            </TabPane>
            <TabPane tab={t(`general.day`)} key="4">
              <Radio.Group onChange={e => handleRadioChange(e, 'day')} value={radioValue['day']}>
                <Radio style={radioStyle} value={1}>
                  {t(`job.executedPerDaily`)}
                </Radio>
                <Radio style={radioStyle} value={2}>
                  {t(`job.noAssign`)}
                </Radio>
                <Radio style={radioStyle} value="period">
                  {t(`job.periodFrom`)}
                  <Form.Item name="periodDayMin" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                        max={31} initialValue={periodValue.day.min}
                                                                                                        onChange={e => handlePeriodChange(e, 'day', 'min')}/></Form.Item>
                  {t(`job.to`)}
                  <Form.Item name="periodDayMax" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                        max={31} initialValue={periodValue.day.max}
                                                                                                        onChange={e => handlePeriodChange(e, 'day', 'max')}/></Form.Item>
                  {t(`general.day`)}
                </Radio>
                <Radio style={radioStyle} value="loop">
                  {t(`job.from`)}
                  <Form.Item name="loopDayStart" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                        max={31} initialValue={loopValue.day.start}
                                                                                                        onChange={e => handleLoopChange(e, 'day', 'start')}/></Form.Item>
                  {t(`job.dayStartPer`)}
                  <Form.Item name="loopDayEnd" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1} max={31}
                                                                                                      initialValue={loopValue.day.end}
                                                                                                      onChange={e => handleLoopChange(e, 'day', 'end')}/></Form.Item>
                  {t(`job.dailyExecuteOnce`)}
                </Radio>
                <Radio style={radioStyle} value="point">
                  {t(`job.assign`)}
                </Radio>
                <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'day')} value={cronParams.day}>
                  {dayCheckbox}
                </Checkbox.Group>
              </Radio.Group>
            </TabPane>
            <TabPane tab={t(`general.month`)} key="5">
              <Radio.Group onChange={e => handleRadioChange(e, 'month')} value={radioValue['month']}>
                <Radio style={radioStyle} value={1}>
                  {t(`job.executedPerMonthly`)}
                </Radio>
                <Radio style={radioStyle} value={2}>
                  {t(`job.noAssign`)}
                </Radio>
                <Radio style={radioStyle} value="period">
                  {t(`job.periodFrom`)}
                  <Form.Item name="periodMonthMin" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                          max={12}
                                                                                                          initialValue={periodValue.month.min}
                                                                                                          onChange={e => handlePeriodChange(e, 'month', 'min')}/></Form.Item>
                  {t(`job.to`)}
                  <Form.Item name="periodMonthMax" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                          max={12}
                                                                                                          initialValue={periodValue.month.max}
                                                                                                          onChange={e => handlePeriodChange(e, 'month', 'max')}/></Form.Item>
                </Radio>
                <Radio style={radioStyle} value="loop">
                  {t(`job.from`)}
                  <Form.Item name="loopMonthStart" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                          max={12}
                                                                                                          initialValue={loopValue.month.start}
                                                                                                          onChange={e => handleLoopChange(e, 'month', 'start')}/></Form.Item>
                  {t(`job.startPer`)}
                  <Form.Item name="loopMonthEnd" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                        max={12} initialValue={loopValue.month.end}
                                                                                                        onChange={e => handleLoopChange(e, 'month', 'end')}/></Form.Item>
                  {t(`job.executeOnce`)}
                </Radio>
                <Radio style={radioStyle} value="point">
                  {t(`job.assign`)}
                </Radio>
                <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'month')} value={cronParams.month}>
                  {monthCheckbox}
                </Checkbox.Group>
              </Radio.Group>
            </TabPane>
            <TabPane tab={t(`general.week`)} key="6">
              <Radio.Group onChange={e => handleRadioChange(e, 'week')} value={radioValue['week']}>
                <Radio style={radioStyle} value={1}>
                  {t(`job.executedPerWeekly`)}
                </Radio>
                <Radio style={radioStyle} value={2}>
                  {t(`job.noAssign`)}
                </Radio>
                <Radio style={radioStyle} value="period">
                  {t(`job.periodFrom`)}
                  <Form.Item name="periodWeekMin" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                         max={7} initialValue={periodValue.week.min}
                                                                                                         onChange={e => handlePeriodChange(e, 'week', 'min')}/></Form.Item>
                  -
                  <Form.Item name="periodWeekMax" style={{width: 50, display: 'table-row'}}><InputNumber style={inputStyle} size="small" min={1}
                                                                                                         max={7} initialValue={periodValue.week.max}
                                                                                                         onChange={e => handlePeriodChange(e, 'week', 'max')}/></Form.Item>
                </Radio>
                <Radio style={radioStyle} value="point">
                  {t(`job.assign`)}
                </Radio>
                <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'week')} value={cronParams.week}>
                  {weekCheckbox}
                </Checkbox.Group>
              </Radio.Group>
            </TabPane>
          </Tabs>
        </Form>
      </>
    )
  }
}

export default withTranslation()(CronGenerator)
